import { useEffect, useState } from 'react'
import { useCasinoStore } from '../../services/store'

export const useSetPendingNotifications = showNotificationPopup => {
  const [pendingNotifications, setPendingNotifications] = useState([])

  const casinoStore = useCasinoStore()
  const casinoHoldNotifications = casinoStore.use.casinoHoldNotifications()

  useEffect(() => {
    if (pendingNotifications && pendingNotifications.length !== 0 && !casinoHoldNotifications) {
      showNotificationPopup(pendingNotifications)
      setPendingNotifications([])
    }
  }, [casinoHoldNotifications, pendingNotifications, setPendingNotifications, showNotificationPopup])

  return { pendingNotifications, setPendingNotifications }
}
